export default class EventConst{
    static SAVE = "savingdata"
    static LOADING = "load"

   }